import axiosInstance from "../Axios/axiosInstance";

const getAllOffers = async () => {
  return await axiosInstance.get("/offers/");
};

const getOfferById = async (id) => {
  return await axiosInstance.get(`/offers/entry/${id}`);
};

const addOffer = async (data) => {
  return await axiosInstance.post("/offers/", data);
};

const editOffer = async (id, data) => {
  return await axiosInstance.put(`/offers/${id}`, data);
};

const deleteOffer = async (id) => {
  return await axiosInstance.delete(`/offers/${id}`);
};

export default {
  getAllOffers,
  getOfferById,
  addOffer,
  editOffer,
  deleteOffer,
};
